import styles from "./Button.module.scss";
import loadingWhiteIcon from "../../assets/loading-white.svg";

const Button = ({
  children,
  onClick,
  className,
  type = "primary",
  htmlType = "button",
  title,
  danger,
  responsive,
  disabled,
  loading,
  size = "default",
  style,
}: {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  type?: "primary" | "accent" | "plain" | "bordered";
  htmlType?: "button" | "submit" | "reset";
  title?: string;
  danger?: boolean;
  responsive?: boolean;
  disabled?: boolean;
  loading?: boolean;
  size?: "small" | "default" | "large";
  style?: React.CSSProperties;
}) => {
  return (
    <button
      className={[
        styles.button,
        className,
        styles[type],
        danger && styles.danger,
        responsive && styles.responsive,
        disabled && styles.disabled,
        loading && styles.loading,
        size && styles[size],
      ].join(" ")}
      onClick={onClick}
      title={title}
      type={htmlType}
      disabled={disabled}
      style={style}
    >
      {children}
      {loading && <img src={loadingWhiteIcon} alt="loading" />}
    </button>
  );
};

export default Button;
